module.exports = require('./lib')['PhoneNumber$$module$src$index'];
Object.defineProperty(module.exports, "__esModule", {
  value: true
});
module.exports.default = module.exports;